module.exports = __webpack_public_path__ + "img/horizontal_3_3_1.3b7c4b98.png";